module.exports = __webpack_public_path__ + "static/img/tj2.a60a12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj2.png
// module id = RsZi
// module chunks = 0